import { addIndexedDBItem } from "utils/indexedDb";
import { UpdateToOnlineStatus } from "constants/serviceWorker";
import { ErrorResponse } from "../../BaseRequestServiceWorker";
import { Operation } from "constants/serviceWorker";
import { iCachedItem } from "interfaces/models/serviceWorker";
import { uuid } from "utils/common";
import BaseCustomResponse from "../../BaseCustomResponse";

export default class BaseCustomDeleteResponse extends BaseCustomResponse {
  async changeResponseData(): Promise<Response> {
    const request = this.event.request.clone();
    let response: Response | undefined = undefined;

    // network first
    if (this.swOnlineStatus) {
      const req = await this.getRequestForFetch();
      response = await fetch(req).catch(() => {
        return ErrorResponse.clone();
      });

      // When error 400 occurs, the service worker side cannot get a response from the server
      // so the error handling logic on the baseAxios side does not work.
      if (![200, 400].includes(response?.status)) {
        return response;
      }
    }

    const body = await request.clone().json();
    const ids = body?.ids || [body?.id];

    const requestId = body?.requestId;
    const now = Date.now();
    const items: string[] = Array.isArray(ids) ? ids : [ids];
    const status = this.swOnlineStatus
      ? UpdateToOnlineStatus.Success
      : UpdateToOnlineStatus.Fail;
    if (items.length && !this.isRequestSyncData(request.url)) {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];

        await addIndexedDBItem({
          id: uuid(),
          data: {
            requestTime: now,
            requestId,
            store: this.storeNameOfRequest,
            operation: Operation.Delete,
            status,
            data: item,
          } as iCachedItem,
        });
      }
    }
    const apiResponse = {
      data: items,
    };

    return this.response({ data: apiResponse, response, isPutToCache: false });
  }
}
